import { Component, input } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';

/**
 * A wrapper for the p-checkbox component. Displays a checkbox with a label
 * next to it.
 *
 * To see examples where this component is used, visit any of the classes that extend the
 * AssessmentFormComponent class (e.g. Cardiovascular, Gastrointestinal, Genitourinary).
 */
@Component({
  selector: 'emr-checkbox',
  templateUrl: './emr-checkbox.component.html',
  styleUrls: ['./emr-checkbox.component.scss'],
  standalone: true,
  imports: [
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class EmrCheckboxComponent {
  /**
   * The text to display next to the checkbox.
   */
  label = input.required();

  /**
   * The FormControl to get/set the value for.
   */
  control = input.required<UntypedFormControl>();
}
